/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import { Icon } from '@iconify/react';
import Avatar from 'components/base/Avatar';
import Button from 'components/base/Button';
import PageLoader from 'components/custom/animate-component/PageLoader';
import ImageInput from 'components/custom/forms/ImageInput';
import LabelDateSelector from 'components/custom/forms/LabelDateSelector';
import LabelInput from 'components/custom/forms/LabelInput';
import CustomModal from 'components/custom/modal/CustomModal';
import apiEndpoints from 'constants/apiEndpoints';
import { useFormik } from 'formik';
import { useAlert } from 'providers/AlertModalProvider';
import React, { useEffect, useRef, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import postData from 'services/postData';
import * as Yup from 'yup';
// import { useRef, useEffect } from 'react';
import EditQuickTrucker from 'views/payment/quick-payment/EditQuickTrucker';
import useShowModal from 'hooks/custom/useShowModal';
import useFetchData from 'hooks/custom/useFetchData';
import fetchData from 'services/fetchData';
import LabelSelector from 'components/custom/forms/LabelSelector';
import { findIndividual } from 'services/utils';
import IncompleteDetailAlert from './IncompleteDetailAlert';
import CreateQuickTruckerVehicleDriver from 'views/operation/Challan/quick-create/CreateQuickTruckerVehicleDriver';
import LabelDateInsert from 'components/custom/forms/LabelDateInsert';

export default function CreatePod({ show, handleClose, refreshData, data }) {
  console.log('🚀 ~ CreatePod ~ data:', data);
  const [loading, setLoading] = useState(false);
  const [isManualUpdate, setIsManualUpdate] = useState(false);
  const suspenseTrucker = data?.trucker_id;
  // const suspenseTrucker = 21;
  const showQuickCreate = useShowModal();
  const showEditTrucker = useShowModal();
  const { showAlert } = useAlert();
  // const alertShown = useRef(false);
  const isTruckerDetailsMissing = !(
    (
      data?.trucker_name &&
      data?.trucker_contact_person_name &&
      data?.trucker_phone &&
      data?.trucker_address &&
      data?.pan_no &&
      data?.trucker_account_holder_name &&
      data?.trucker_bank_name &&
      data?.trucker_account_number &&
      data?.trucker_bank_ifsc
    )
    // data?.trucker_rate
  );

  // useEffect(() => {
  //   if (isTruckerDetailsMissing) {
  //     showAlert({
  //       variant: 'warning',
  //       message: 'Trucker info not found. Please update the details.'
  //     });
  //   }
  // }, [isTruckerDetailsMissing, showAlert]);

  const [vehicleOption, setVehicleOption] = useState([]);

  const { 0: truckerOption, 3: refreshTruckerOpt } = useFetchData(
    apiEndpoints.trucker.getAssignedTruckers
  );
  const { 0: discounterOption, 3: refreshDiscounterOpt } = useFetchData(
    apiEndpoints.trucker.getDiscounterList
  );

  const fetchRequest = async id => {
    const response = await fetchData(
      apiEndpoints.vehicle.getVehicleTrucker(id)
    );

    if (response.status) {
      const fetchedData = response.data;
      setVehicleOption(fetchedData);
    } else {
      setVehicleOption([]);
    }
  };
  const formik = useFormik({
    initialValues: {
      gross_weight: '',
      tare_weight: '',
      pod_file: '',
      receiving_date: '',
      challan_no: data?.challan_no,
      challan_id: data?.challan_id,
      penalty_reason: '',
      penalty_amount: '',
      pay_to_id: '',
      pay_to_name: '',
      trucker_id: data?.trucker_id,
      net_weight: '',
      loading_expenses: data.loading_expenses || '',
      short_qty_threshold: data.short_qty_threshold || '',
      shortages_deduction_amount: data.shortages_deduction_amount || ''
    },
    validationSchema: Yup.object({
      driver_name: Yup.string(),
      vehicle_id: Yup.string(),
      trucker_id: Yup.string(),
      penalty_amount: Yup.string(),
      penalty_reason: Yup.string(),
      gross_weight: Yup.number().required(' Gross Weight is required'),
      tare_weight: Yup.number().required(' Tare Weight is required'),
      pod_file: Yup.mixed().required('Attachment is required'),
      receiving_date: Yup.mixed().required('Date Time is required'),
      challan_id: Yup.string(),
      net_weight: Yup.string(),
      loading_expenses: Yup.string(),
      short_qty_threshold: Yup.string(),
      shortages_deduction_amount: Yup.string()

      // challan_no: Yup.string()
    }),

    onSubmit: async values => {
      setLoading(true);
      try {
        const response = await postData(
          values,
          apiEndpoints.challan.receivePod
        );
        if (response?.status) {
          //   setSelectedTruckerDetail(response.data);
          showAlert({
            variant: 'success',
            message: 'Receive POD has been Created successfully.'
          });
          refreshData();
          handleClose();
        } else {
          let errorObj = response.errors;
          if (errorObj) {
            formik.setErrors(
              Object.keys(response.errors)?.reduce(
                (acc, er) => ({ ...acc, [er]: errorObj[er][0] }),
                {}
              )
            );
          }
          showAlert({
            variant: 'danger',
            message: `Failed to Create Receive POD. ${response.message}`
          });
        }
      } catch (error) {
        console.log('🚀 ~ CreatePod ~ error:', error);
        showAlert({
          variant: 'danger',
          message: 'An unexpected error occurred. Please try again.'
        });
      } finally {
        setLoading(false);
      }
    }
  });

  const refreshDataRef = useRef(null);
  const handleRefresh = () => {
    if (refreshDataRef.current) {
      refreshDataRef.current();
    }
  };
  useEffect(() => {
    const { gross_weight, tare_weight } = formik.values;

    if (gross_weight && tare_weight) {
      const netWeight = (Number(gross_weight) - Number(tare_weight)).toFixed(2);
      formik.setFieldValue('net_weight', netWeight);
    }
  }, [formik.values.gross_weight, formik.values.tare_weight]);

  // const updateSuccessfully = () => {
  //   handleClose();
  // };
  return (
    <>
      <CustomModal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="medium"
        centered
      >
        <>
          <>
            <Modal.Header
              className="border-0 position-relative pb-0 end-0 dark__text-white"
              closeButton={!loading}
            >
              <div className="d-flex align-items-center mb-2">
                <Avatar size="xl" variant="name" className="me-2">
                  <Icon icon={'icon-park-outline:add-user'} fontSize="18px" />
                </Avatar>
                Receive POD "{data?.challan_no}"
              </div>
            </Modal.Header>

            <Modal.Body className="pt-2 position-relative">
              <Row className="">
                {(isTruckerDetailsMissing ||
                  data?.change_flag == 1 ||
                  isManualUpdate) && (
                  <>
                    <IncompleteDetailAlert
                      data={data}
                      isManualUpdate={isManualUpdate}
                      onCompleteNow={showEditTrucker.handleOpenModal}
                    />
                  </>
                )}
                {suspenseTrucker === 21 && (
                  <>
                    <Col className="mt-2" xs={12} sm={12} lg={12}>
                      <LabelSelector
                        placeholder={'Select Trucker'}
                        label={'Trucker'}
                        errorProps={{ tooltip: false }}
                        inputProps={{
                          readOnly: isTruckerDetailsMissing ? true : false
                        }}
                        options={{
                          data: truckerOption,
                          formatter: option => ({
                            label: `${option.trucker_name}`,
                            value: option.trucker_id,
                            desc: `type - ${option.trucker_type}`
                          })
                        }}
                        callbackOnChange={opt => {
                          const selectedV = findIndividual(
                            truckerOption,
                            'trucker_id',
                            opt.value
                          );
                          fetchRequest(selectedV.trucker_id);
                          formik.setFieldValue(
                            'driver',
                            selectedV?.vehicle_name
                          );
                        }}
                        controlId={'trucker_id'}
                        formik={formik}
                        required
                      />
                      <Button
                        onClick={showQuickCreate.handleOpenModal}
                        variant="link"
                        className="p-0 fs-10"
                      >
                        Create Quick Trucker
                      </Button>
                    </Col>
                  </>
                )}
                <Col className="mt-2" xs={12} sm={12}>
                  <LabelInput
                    required
                    errorProps={{ tooltip: false }}
                    // inputProps={{ type: 'number' }}
                    inputProps={{
                      readOnly: isTruckerDetailsMissing ? true : false,
                      type: 'number'
                    }}
                    label={'Gross Weight(in MT)'}
                    controlId={'gross_weight'}
                    formik={formik}
                    // information={'The Latitude must be a decimal number'}
                  />
                </Col>
                <Col className="mt-2" sm={12}>
                  <LabelInput
                    required
                    errorProps={{ tooltip: false }}
                    // inputProps={{ type: 'number' }}
                    inputProps={{
                      readOnly: isTruckerDetailsMissing ? true : false,
                      type: 'number'
                    }}
                    label={'Tare Weight(in MT)'}
                    controlId={'tare_weight'}
                    formik={formik}
                    // information={'The Longitude must be a decimal number'}
                  />
                </Col>

                <Col className="mt-2" sm={12}>
                  <LabelInput
                    errorProps={{ tooltip: false }}
                    // inputProps={{ type: 'number' }}
                    inputProps={{
                      readOnly: true,
                      type: 'number'
                    }}
                    label={'Net Weight(in MT)'}
                    controlId={'net_weight'}
                    formik={formik}
                  />
                </Col>

                <Col className="mt-2" sm={12}>
                  <LabelInput
                    errorProps={{ tooltip: false }}
                    inputProps={{
                      type: 'number'
                    }}
                    label={'Loading Expenses'}
                    controlId={'loading_expenses'}
                    formik={formik}
                  />
                </Col>

                <Col className="mt-2" sm={12}>
                  <LabelInput
                    errorProps={{ tooltip: false }}
                    // inputProps={{ type: 'number' }}
                    inputProps={{
                      readOnly: isTruckerDetailsMissing ? true : false,
                      type: 'number'
                    }}
                    label={'Penalty Charges Amount'}
                    controlId={'penalty_amount'}
                    formik={formik}
                  />
                </Col>
                <Col className="mt-2" sm={12}>
                  <LabelInput
                    errorProps={{ tooltip: false }}
                    // inputProps={{ type: '' }}
                    inputProps={{
                      readOnly: isTruckerDetailsMissing ? true : false,
                      type: ''
                    }}
                    label={'Penalty Reason'}
                    controlId={'penalty_reason'}
                    formik={formik}
                  />
                </Col>

                {/* <Col sm={6} className="px-sm-2 mt-3 mt-sm-0">
                  <LabelDateInsert
                    controlId="spouse_date_of_birth"
                    label="Spouse Date of Birth"
                    formik={formik}
                    required
                  />
                </Col> */}

                <Col className="mt-2" sm={12}>
                  <LabelDateSelector
                    errorProps={{ tooltip: false }}
                    controlId="receiving_date"
                    label="Date and Time"
                    formik={formik}
                    dateOptions={{
                      datePostFormate: 'YYYY-MM-DD hh:mm:ss',
                      enableTime: 'true',
                      dateFormat: 'Y-m-d H:i:S',
                      altFormat: 'd-m-Y h:i K',
                      maxDate: '',
                      static: true
                    }}
                    required
                  />
                </Col>
                <Col xs={12} className="mt-2">
                  <ImageInput
                    message={<small>POD Attachment</small>}
                    file={formik.values['pod_file']}
                    setFile={file => formik.setFieldValue('pod_file', file)}
                    handleTouched={() =>
                      formik.setFieldTouched('pod_file', true)
                    }
                    touched={formik.touched['pod_file']}
                    error={formik.errors['pod_file']}
                    controlId={'pod_file'}
                  />
                </Col>

                {suspenseTrucker !== 21 && (
                  <>
                    <Col className="mt-3" xs={12} sm={12} lg={12}>
                      <div className="w-100 border-top border-300 mb-2"></div>
                      <LabelSelector
                        placeholder={'Select Discounter'}
                        label={'Discounter'}
                        errorProps={{ tooltip: false }}
                        options={{
                          data: discounterOption,
                          formatter: option => ({
                            label: `${option.trucker_name}`,
                            value: option.trucker_id,
                            desc: `type - Discounter`
                          })
                        }}
                        controlId={'pay_to_id'}
                        controlLabelId={'pay_to_name'}
                        formik={formik}
                      />
                    </Col>
                  </>
                )}
              </Row>
            </Modal.Body>
          </>

          <Modal.Footer className="d-flex justify-content-center">
            <Button
              variant="phoenix-secondary"
              disabled={loading}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="phoenix-success"
              disabled={loading}
              onClick={formik.handleSubmit}
            >
              Submit
            </Button>
          </Modal.Footer>
          <PageLoader loading={loading} loadingMessage={'Receive POD'} />
        </>
        {/* {showModal && (
          <EditQuickTrucker
            show={showModal}
            handleClose={() => setShowModal(false)}
          />
        )} */}
        {showEditTrucker.isOpen && (
          <EditQuickTrucker
            show={showEditTrucker.isOpen}
            handleClose={showEditTrucker.handleCloseModal}
            data={data}
            handleRefresh={handleRefresh}
            setIsManualUpdate={setIsManualUpdate}
            // updateSuccessfully={updateSuccessfully}
          />
        )}
        {showQuickCreate.isOpen && (
          <CreateQuickTruckerVehicleDriver
            show={showQuickCreate.isOpen}
            handleClose={showQuickCreate.handleCloseModal}
            fetchLoading={loading}
            defaultData={{
              trucker_id: formik.values.trucker_id || '',
              vehicle_id: formik.values.vehicle_id || '',
              driver_id: formik.values.driver_id || ''
            }}
            handleSelect={async ids => {
              setLoading(true);
              formik.setFieldValue('trucker_id', ids.trucker_id);
              formik.setFieldValue('vehicle_id', ids.vehicle_id);
              formik.setFieldValue('driver_id', ids.driver_id);
              refreshTruckerOpt();
              // fetchRequest(ids.trucker_id);
              const response = await fetchData(
                apiEndpoints.vehicle.getVehicleTrucker(ids.trucker_id)
              );

              if (response.status) {
                const fetchedData = response.data;
                setVehicleOption(fetchedData);
                const selectedV = findIndividual(
                  fetchedData,
                  'vehicle_id',
                  ids.vehicle_id
                );
                formik.setFieldValue('driver_name', selectedV?.driver_name);

                formik.setFieldValue(
                  'vehicle_number',
                  selectedV?.vehicle_number
                );

                formik.setFieldValue(
                  'driver_upi_name',
                  selectedV?.driver_upi_name || ''
                );
                formik.setFieldValue(
                  'driver_upi_id',
                  selectedV?.driver_upi_id || ''
                );
                formik.setFieldValue(
                  'driver_mobile',
                  selectedV?.driver_mobile || ''
                );
              } else {
                setVehicleOption([]);
                setLoading(false);
              }
              setTimeout(() => {
                showQuickCreate.handleCloseModal();
                setLoading(false);
              }, 500);
            }}
          />
        )}
      </CustomModal>
    </>
  );
}
